/* =============================
   assets/handmailed-category.js
   ============================= */
(() => {
  const els = document.querySelectorAll('.hm-cat');
  if (!els.length) return;

  els.forEach(root => {
    const debug = root.dataset.debug === 'true';
    const pills = root.querySelectorAll('.hm-pill');
    const grid  = root.querySelector('[data-hm-grid]');
    const tiles = grid ? grid.querySelectorAll('[data-hm-product]') : [];
    const countEl = root.querySelector('[data-hm-visible-count]');
    const countsWrap = root.querySelector('[data-hm-counts]');
    const emptyEl = root.querySelector('[data-hm-empty]');

    if (debug) document.documentElement.classList.add('hm-debug-outline');

    // ---- URL helpers (missing in your file) ----
    const getParamMood = () => {
      try {
        const url = new URL(window.location.href);
        return (url.searchParams.get('mood') || '').toLowerCase();
      } catch {
        return '';
      }
    };
    const setParamMood = (key) => {
      try {
        const url = new URL(window.location.href);
        if (key === 'all') url.searchParams.delete('mood');
        else url.searchParams.set('mood', key);
        window.history.replaceState({}, '', url.toString());
      } catch {
        /* no-op */
      }
    };

    // ---- UI helpers ----
    const setActive = (key) => {
      pills.forEach(p => {
        const active = p.dataset.mood === key;
        p.classList.toggle('is-active', active);
        p.setAttribute('aria-selected', String(active));
      });
    };

    const updateCount = () => {
      if (!grid || !countEl) return;
      const visible = grid.querySelectorAll('[data-hm-product]:not([hidden])').length;
      countEl.textContent = visible;
      if (countsWrap && countsWrap.hasAttribute('hidden')) countsWrap.removeAttribute('hidden');
    };

    const showEmpty = (shouldShow) => {
      if (!emptyEl) return;
      emptyEl.toggleAttribute('hidden', !shouldShow);
    };

    const animateInVisible = () => {
      if (!grid) return;
      const vis = Array.from(grid.querySelectorAll('[data-hm-product]:not([hidden])'));
      vis.forEach((el, i) => {
        el.style.setProperty('--enter-i', i);
        el.classList.remove('is-enter');
        // force reflow
        // eslint-disable-next-line no-unused-expressions
        el.offsetWidth;
        el.classList.add('is-enter');
      });
    };

    const filterByMood = (key) => {
      if (!tiles || !tiles.length) {
        updateCount();
        showEmpty(true);
        return;
      }
      let visibleCount = 0;
      tiles.forEach(t => {
        const moods = (t.getAttribute('data-moods') || '').split(/\s+/).filter(Boolean);
        const show = (key === 'all') || moods.includes(key);
        t.toggleAttribute('hidden', !show);
        if (show) visibleCount++;
      });
      updateCount();
      showEmpty(visibleCount === 0);
      animateInVisible();
    };

    // ---- Events ----
    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        const key = pill.dataset.mood;
        setActive(key);
        setParamMood(key);
        filterByMood(key);
      });
    });

    // ---- Init ----
    const initial = (() => {
      const q = getParamMood();
      const allowed = Array.from(pills).map(p => (p.dataset.mood || '').toLowerCase());
      return allowed.includes(q) ? q : 'all';
    })();

    setActive(initial);
    filterByMood(initial);
  });
})();
